/**
 * Содержимое элемента GraphQL запроса
 */
export interface PimcoreQueryListingContent {
  id: number;
  [key: string]: any;
}

/**
 * Элемента листинга GraphQL запроса
 */
export interface PimcoreQueryListingItem {
  node: PimcoreQueryListingContent;
  typename: string;
}

/**
 * Ответ листинга GraphQL запроса
 */
export interface PimcoreQueryListingResponse {
  items: PimcoreQueryListingItem[];
  total: number;
}

export interface PimcoreType {
  kind: PimcoreTypeKind;
  name: string;
  fields?: PimcoreEntityType[];
  ofType?: PimcoreFieldType;
}

export type PimcoreTypeKind =
  | 'SCALAR'
  | 'OBJECT'
  | 'INTERFACE'
  | 'UNION'
  | 'ENUM'
  | 'INPUT_OBJECT'
  | 'LIST'
  | 'NON_NULL'

export interface PimcoreFieldType extends PimcoreType {
  possibleTypes?: PimcoreType[] | null;
}

export interface PimcoreEntityType {
  name: string;
  type: PimcoreFieldType;
}

export interface PimcoreEntity {
  fields: Array<PimcoreEntityType>;
}

export interface PimcoreEntityNavigation {
  name: string;
  title: string;
  type: string;
}

export interface FieldOptions {
  key: string;
  value: any;
}

export enum LayoutFieldType {
  input = 'input',
  numeric = 'numeric',
  panel = 'panel',
}

/**
 * Элемент поля кастомных шаблонов
 */
export interface PimcoreLayoutInput {
  /**
   * Тип поля
   */
  fieldtype: LayoutFieldType;

  /**
   * Ширина поля
   */
  width: number | null;

  /**
   * Наименование поля
   */
  name: string;

  /**
   * Заголовок поля
   */
  title: string;

  /**
   * Положительное значение в логическом поле
   */
  yesLabel: string;

  /**
   * Отрицательное значение в логическом поле
   */
  noLabel: string;

  /**
   * Варианты выбора
   */
  options: FieldOptions[];

  [key: string]: any;
}

/**
 * Панель шаблона формы
 */
export interface PimcoreLayoutPanel {
  /**
   * Тип поля
   */
  fieldtype: LayoutFieldType;

  /**
   * Ширина заголовка
   */
  labelWidth: number | null;

  /**
   * Массив вложенных элементов
   */
  childs: Array<PimcoreLayoutPanel|PimcoreLayoutInput>;

  /**
   * Наименование раздела
   */
  name: string;

  [key: string]: any;
}

/**
 * Шаблоны форм pimcore
 */
export interface PimcoreEntityLayout {
  /**
   * Описание шаблона
   */
  description: string;

  /**
   * Описание элементов шаблона
   */
  layoutDefinitions: PimcoreLayoutPanel;

  /**
   * Шаблон по умолчанию
   */
  default: number;
}

/**
 * Состояния загрузки макетов
 */
export enum PimcoreLayoutState {
  initial = '',
  loading = 'loading',
  loadedEmpty = 'empty',
}
